import { toast } from "../components/layout/app-toast/utils/toastManager.js";

const baseURL = typeof __API_BASE_URL__ !== "undefined" ? __API_BASE_URL__ : "http://localhost:5194/api";

export const logoutURL = `${baseURL}/auth/logout`;
export const loginURL = `${baseURL}/auth/login`;

export function isErrorResult(result) {
    return !result || result === 400 || result === 404 || result === 409;
}

let isRedirectingToLogin = false;

function redirectToLogin() {
    if (!isRedirectingToLogin) {
        isRedirectingToLogin = true;
        window.location.href = loginURL;
    }
}

function isNetworkError(error) {
    return error instanceof TypeError;
}

export async function pingServer() {
    try {
        await fetch(`${baseURL}/users/me`, { method: "GET", credentials: "include" });
        return true;
    } catch {
        return false;
    }
}

async function goOffline() {
    const { showOfflineView } = await import("./views/infoView.js");
    showOfflineView();
}

async function handleNetworkFailure() {
    await goOffline();
}

function buildErrorMessage(status, url) {
    switch (status) {
        case 403: return "Du bist nicht autorisiert!";
        case 500: return `Interner Serverfehler bei: [${url}]`;
        default:  return `Fehler ${status} bei [${url}]`;
    }
}

export async function apiFetch(path, method = "GET", body, { silent = false, silentNotFound = false, silentConflict = false, silentBadRequest = false } = {}) {
    const url = `${baseURL}/${path}`;
    try {
        const options = { method, credentials: "include", headers: { "Content-Type": "application/json" }};
        if (body) {
            options.body = JSON.stringify(body)
        };

        const response = await fetch(url, options);

        if (response.status === 401 || (response.redirected && !response.url.startsWith(baseURL))) {
            redirectToLogin();
            return;
        }

        if (response.status === 400) {
            const text = await response.text().catch(() => null);
            if (!silentBadRequest) toast(text || buildErrorMessage(response.status, url), "error");
            return 400;
        }

        if (response.status === 404) {
            const text = await response.text().catch(() => null);
            if (text && !silentNotFound) toast(text, method === "DELETE" ? "info" : "error");
            return 404;
        }

        if (response.status === 409) {
            const text = await response.text().catch(() => null);
            if (text && !silentConflict) toast(text, "error");
            return 409;
        }

        if (!response.ok) {
            if (silent) return response.status;

            const text = await response.text().catch(() => null);
            toast(text || buildErrorMessage(response.status, url), "error");
            return null;
        }

        const contentType = response.headers.get("content-type") || "";
        const contentLength = response.headers.get("content-length");
        if (response.status === 204 || contentLength === "0" || !contentType.includes("application/json")) {
            return true;
        }

        return await response.json();
    }
    catch (error) {
        if (isNetworkError(error)) {
            await handleNetworkFailure();
        } else {
            toast("Es ist ein unerwarteter Fehler aufgetreten.", "error");
        }
        throw error;
    }
}